import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { ACCOUNT_MANAGER_GROUP } from '../../fields';
import { ACCOUNT_MANAGER_GROUP_VIDEO_REPORT_ID } from './accountManagerGroupVideoReportId';

const reportFooterColumnDefinition = [ACCOUNT_MANAGER_GROUP].map(
    createFooterMapper(ACCOUNT_MANAGER_GROUP_VIDEO_REPORT_ID)
);

export default reportFooterColumnDefinition;
